/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import { User, UserFromJSON, UserFromJSONTyped, UserToJSON } from "./User";

/**
 *
 * @export
 * @interface UserListResponse
 */
export interface UserListResponse {
  /**
   *
   * @type {number}
   * @memberof UserListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof UserListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof UserListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof UserListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof UserListResponse
   */
  count: number;
  /**
   *
   * @type {Array<User>}
   * @memberof UserListResponse
   */
  data: Array<User>;
}

export function UserListResponseFromJSON(json: any): UserListResponse {
  return UserListResponseFromJSONTyped(json, false);
}

export function UserListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(UserFromJSON),
  };
}

export function UserListResponseToJSON(value?: UserListResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(UserToJSON),
  };
}
